import React, { useContext, useEffect, useState } from "react";
import { useForm, Controller } from "react-hook-form";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { contact_us } from "../../component/services/ApiCalls";
import { AppStoreContext } from "../../store/AppStore";
import consoleService from "../../utility/services/consoleService";
import {
  isBlockedEmailDomain,
  PROFESSIONAL_EMAIL_MSG,
} from "../utils/blockedEmailDomains";
import TurnstileWidget from "../components/TurnstileWidget";
import "../sass/MottruckLanding.scss";
import "./ContactDemo.scss";

const Contacts = () => {
  const defaultValues = {
    name: "",
    email: "",
    phone: "",
    company: "",
    message: "",
  };
  const { setIsLoading } = useContext(AppStoreContext);
  const infoForm = useForm({ defaultValues });
  const { control, handleSubmit, setError, reset, formState } = infoForm;
  const { errors } = formState;
  const [turnstileToken, setTurnstileToken] = useState(null);
  const [turnstileReset, setTurnstileReset] = useState(0);

  const onSubmit = async (data) => {
    if (Object.values(data).every((field) => field.toString().trim().length > 0)) {
      if (isBlockedEmailDomain(data.email)) {
        toast.error(PROFESSIONAL_EMAIL_MSG);
        return;
      }
      if (!turnstileToken) {
        toast.error("Please complete the security check.");
        return;
      }
      try {
        contact_us({
          ...data,
          subject: "contact message",
          turnstileToken,
        })
          .then((res) => {
            if (res.status == 1) {
              toast("Thanks, We will be get in touch with you asap");
              reset();
              setTurnstileToken(null);
              setTurnstileReset((n) => n + 1);
            } else {
              toast.error(res?.msg || "Something went wrong. Please try again.");
              setTurnstileToken(null);
              setTurnstileReset((n) => n + 1);
            }
          })
          .catch((err) => {
            console.log("err", err);
            toast("Something went wrong. Please try again.");
            setTurnstileToken(null);
            setTurnstileReset((n) => n + 1);
          });
      } catch (err) {
        consoleService("error in onSubmitInfoForm function:", err);
      }
    } else {
      for (const key in data) {
        if (data[key].length === 0) {
          setError(key, { type: "manual", message: `${key} is required` });
        }
      }
    }
  };

  useEffect(() => {
    setIsLoading(false);
  }, [setIsLoading]);

  return (
    <div className="mtk-landing mtk-split-page mtk-contact-page">
      <section className="mtk-split-section">
        <div className="mtk-split-grid">
          <div className="mtk-split-left mtk-contact-left">
            <div className="mtk-contact-stack">
              <h1
                className="mtk-contact-title"
                aria-label="Let's get your freight moving."
              >
                {["Let's get your", "freight moving."].map((line) => (
                  <span className="mtk-track-line" aria-hidden="true" key={line}>
                    {line.split("").map((ch, i) => (
                      <span key={`${line}-${i}`}>{ch === " " ? "\u00A0" : ch}</span>
                    ))}
                  </span>
                ))}
              </h1>
            </div>
          </div>

          <div className="mtk-split-right">
            <form className="mtk-split-form" onSubmit={handleSubmit(onSubmit)}>
              <div className="field">
                <label>Name</label>
                <Controller
                  name="name"
                  control={control}
                  render={({ field }) => (
                    <input type="text" placeholder="John Carter" {...field} />
                  )}
                />
                {errors.name && <small className="err">{errors.name.message}</small>}
              </div>
              <div className="field">
                <label>Email</label>
                <Controller
                  name="email"
                  control={control}
                  render={({ field }) => (
                    <input type="email" placeholder="name@company.com" {...field} />
                  )}
                />
                {errors.email && (
                  <small className="err">{errors.email.message}</small>
                )}
              </div>
              <div className="field-row">
                <div className="field">
                  <label>Phone</label>
                  <Controller
                    name="phone"
                    control={control}
                    render={({ field }) => (
                      <input type="text" placeholder="+33 6 00 00 00" {...field} />
                    )}
                  />
                </div>
                <div className="field">
                  <label>Company</label>
                  <Controller
                    name="company"
                    control={control}
                    render={({ field }) => (
                      <input type="text" placeholder="Your company" {...field} />
                    )}
                  />
                </div>
              </div>
              <div className="field field-message">
                <label>Message</label>
                <Controller
                  name="message"
                  control={control}
                  render={({ field }) => (
                    <textarea placeholder="Let us know how we can help." rows={4} {...field} />
                  )}
                />
              </div>
              <div className="mtk-turnstile-slot">
                <TurnstileWidget
                  onToken={setTurnstileToken}
                  resetKey={turnstileReset}
                />
                <button type="submit" className="mtk-split-submit">
                  Send message
                </button>
              </div>
            </form>
          </div>
        </div>
      </section>
      <ToastContainer />
    </div>
  );
};

export default Contacts;
